import comp from "./FieldAIEvaluationLanguage";
export default comp;
